'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _redboxReact2 = require('redbox-react');

var _redboxReact3 = _interopRequireDefault(_redboxReact2);

var _react2 = require('react');

var _react3 = _interopRequireDefault(_react2);

var _reactTransformCatchErrors3 = require('react-transform-catch-errors');

var _reactTransformCatchErrors4 = _interopRequireDefault(_reactTransformCatchErrors3);

var _helpers = require('helpers');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _components = {
    OperationsItem: {
        displayName: 'OperationsItem'
    }
};

var _reactTransformCatchErrors2 = (0, _reactTransformCatchErrors4.default)({
    filename: '/usr/local/ibonus/src/components/Operations/OperationsItem.jsx',
    components: _components,
    locals: [],
    imports: [_react3.default, _redboxReact3.default]
});

function _wrapComponent(id) {
    return function (Component) {
        return _reactTransformCatchErrors2(Component, id);
    };
}

var OperationsItem = _wrapComponent('OperationsItem')(function (_Component) {
    (0, _inherits3.default)(OperationsItem, _Component);

    function OperationsItem() {
        (0, _classCallCheck3.default)(this, OperationsItem);
        return (0, _possibleConstructorReturn3.default)(this, (OperationsItem.__proto__ || (0, _getPrototypeOf2.default)(OperationsItem)).call(this));
    }

    (0, _createClass3.default)(OperationsItem, [{
        key: 'render',
        value: function render() {
            var View = _helpers.ThemeHelper.getViewForComponent('OperationsItem', null, { folderName: 'Operations' });
            return _react3.default.createElement(View, { item: this.props.item, lang: this.props.lang });
        }
    }]);
    return OperationsItem;
}(_react2.Component));

exports.default = OperationsItem;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/Operations/OperationsItem.jsx
// module id = 1698
// module chunks = 0